export default {
  PORTRAIT: 1,
  LANDSCAPE: 2,
};
